export class BranchgDefault {
    constructor() {
        this.user = null;
        this.branch = null;
        this.isDefaultBranch = true;
       
    }}